import React from "react";
import Flex from "Trackalyze/Flex";

import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import FilterActivitiesContent from "./FilterActivitiesContent";
import { ListItem } from "Trackalyze/List";

const FilterActivities = ({ standalone }) => {
  const { t } = useTranslation();

  return standalone ? (
    <FilterActivitiesContent standalone={standalone} />
  ) : (
    <ListItem>
      <Flex vertical spacing="3" padding="s">
        <Flex spacing="3" out itemscenter>
          <Typo type="label" size="l">
            {t("trackManager.filterOptionsActivities")}
          </Typo>
        </Flex>
        <FilterActivitiesContent standalone={standalone} />
      </Flex>
    </ListItem>
  );
};

export default React.memo(FilterActivities); // Consider memoizing this component too
